import React from "react";
import { Stack, Typography } from "@mui/material";

const BioDisplay = ({
  longDescription,
  placeHolder,
}) => {
  return (
    <Stack
      mt={3}
      width="100%"
      maxWidth={{
        xs: "100%",
        md: "490px",
        lg: "100%",
      }}
      maxHeight={320}
      sx={{
        overflowX: "auto",
        overflowY: "auto",
      }}
    >
      {!!longDescription.length ? (
        <Typography
          component="p"
          variant="body1"
          sx={{ whiteSpace: "break-spaces" }}
        >
          {longDescription}
        </Typography>
      ) : (
        <Typography
          component="p"
          variant="body1"
          sx={{
            whiteSpace: "break-spaces",
            color: "text.disabled",
          }}>
          {placeHolder}
        </Typography>
      )}
    </Stack>
  );
};

export default BioDisplay;